var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSchedule = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "rthvu79xfa",
  x1: "50%",
  x2: "50%",
  y1: "100%",
  y2: "0%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#ABDBFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#E5F2FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "y6lc85hm2b",
  x1: "50%",
  x2: "50%",
  y1: "191.247%",
  y2: ".412%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#6852FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#00BEFF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hiy64u926c",
  x1: "50%",
  x2: "50%",
  y1: "100%",
  y2: ".412%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#6852FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#00BEFF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "zkpfc1x7cd",
  x1: "50%",
  x2: "50%",
  y1: "100%",
  y2: ".412%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#6852FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#00BEFF"
})))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-573 -30) translate(573 30)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 20,
  height: 18,
  y: 2,
  fill: "url(#rthvu79xfa)",
  rx: 3.333
}), /*#__PURE__*/React.createElement("rect", {
  width: 4,
  height: 2.5,
  x: 2,
  y: 11,
  fill: "url(#y6lc85hm2b)",
  rx: 0.8
}), /*#__PURE__*/React.createElement("rect", {
  width: 4,
  height: 2.5,
  x: 8,
  y: 11,
  fill: "url(#y6lc85hm2b)",
  rx: 0.8
}), /*#__PURE__*/React.createElement("rect", {
  width: 4,
  height: 2.5,
  x: 14,
  y: 11,
  fill: "url(#y6lc85hm2b)",
  rx: 0.8
}), /*#__PURE__*/React.createElement("rect", {
  width: 4,
  height: 2.5,
  x: 2,
  y: 15,
  fill: "url(#y6lc85hm2b)",
  rx: 0.8
}), /*#__PURE__*/React.createElement("rect", {
  width: 4,
  height: 2.5,
  x: 8,
  y: 15,
  fill: "url(#y6lc85hm2b)",
  rx: 0.8
}), /*#__PURE__*/React.createElement("rect", {
  width: 4,
  height: 2.5,
  x: 14,
  y: 15,
  fill: "url(#y6lc85hm2b)",
  rx: 0.8
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#hiy64u926c)",
  d: "M3.333 2h13.334C18.507 2 20 3.492 20 5.333V9H0V5.333C0 3.493 1.492 2 3.333 2z"
}), /*#__PURE__*/React.createElement("rect", {
  width: 2,
  height: 4,
  x: 4,
  fill: "url(#zkpfc1x7cd)",
  rx: 1
}), /*#__PURE__*/React.createElement("rect", {
  width: 2,
  height: 4,
  x: 14,
  fill: "url(#zkpfc1x7cd)",
  rx: 1
}))))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgSchedule);
export default ForwardRef;